export default "__VITE_ASSET__CdJMGdg8__"